import api from '@/config/api'
import type { ApiResponse } from '@/shared/types/api'
import type { EmailStats, SmtpConfig, EmailTemplate } from '../types/email-admin'
import type { AuditLogEntry } from '../types/audit-log'

export async function getEmailStats(): Promise<EmailStats> {
  const response = await api.get<ApiResponse<EmailStats>>('/api/admin/emails/stats')
  return response.data.data
}

export async function getSmtpConfig(): Promise<SmtpConfig> {
  const response = await api.get<ApiResponse<SmtpConfig>>('/api/admin/emails/smtp-config')
  return response.data.data
}

export async function getRecentEmails(limit: number = 20): Promise<AuditLogEntry[]> {
  const response = await api.get<ApiResponse<AuditLogEntry[]>>(`/api/admin/emails/recent?limit=${limit}`)
  return response.data.data
}

export async function sendTestEmail(email: string): Promise<{ recipient: string }> {
  const response = await api.post<ApiResponse<{ recipient: string }>>('/api/admin/emails/test', { email })
  return response.data.data
}

export async function getEmailTemplates(): Promise<EmailTemplate[]> {
  const response = await api.get<ApiResponse<EmailTemplate[]>>('/api/admin/emails/templates')
  return response.data.data
}

export async function updateEmailTemplate(code: string, data: { subject: string; body: string }): Promise<EmailTemplate> {
  const response = await api.put<ApiResponse<EmailTemplate>>(`/api/admin/emails/templates/${code}`, data)
  return response.data.data
}
